export default __webpack_public_path__ + "static/media/7.1be03ac5.svg";